import { useNavigate } from 'react-router-dom';
import { C, ff } from '../../Dashboard/components/dashboardConstants';

function Label({ children, large }) {
  return (
    <span style={{
      fontFamily: ff, fontSize: large ? '20px' : '14px', fontWeight: 700,
      color: C.bk, letterSpacing: '-0.03em', lineHeight: '140%',
    }}>
      {children}
    </span>
  );
}

function Value({ children, large }) {
  return (
    <span style={{
      fontFamily: ff, fontSize: large ? '18px' : '14px', fontWeight: 400,
      color: '#444', letterSpacing: '-0.03em', lineHeight: '160%',
    }}>
      {children}
    </span>
  );
}

function Field({ label, children, style, labelLarge }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', ...style }}>
      <Label large={labelLarge}>{label}</Label>
      {children}
    </div>
  );
}


export default function DetailAnnouncement({ data, castingPostId }) {
  const navigate = useNavigate();

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>

      <div style={{
        background: C.white,
        border: `1px solid ${C.g200}`,
        borderRadius: '16px',
        padding: '22px 24px',
        display: 'flex',
        flexDirection: 'column',
        gap: '18px',
      }}>
        {/* 역할 설명 + 마감 배지 + 공고 상세 보기 버튼 */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '16px' }}>
          <Field label="역할 설명" labelLarge style={{ flex: 1 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
              <Value large>{data.roleDesc}</Value>
              {data.isClosed && (
                <span style={{
                  display: 'inline-flex', alignItems: 'center',
                  padding: '3px 10px',
                  background: '#F3F3F5',
                  border: '1px solid #E0E0E5',
                  borderRadius: '6px',
                  fontFamily: ff,
                  fontSize: '13px',
                  fontWeight: 600,
                  color: '#888896',
                  letterSpacing: '-0.03em',
                  whiteSpace: 'nowrap',
                }}>
                  마감
                </span>
              )}
            </div>
          </Field>
          {castingPostId && (
            <button
              onClick={() => navigate(`/auditions/${castingPostId}`)}
              style={{
                flexShrink: 0,
                padding: '8px 16px',
                background: '#090909',
                border: 'none',
                borderRadius: '5px',
                fontFamily: ff,
                fontSize: '13px',
                fontWeight: 600,
                color: '#FFFFFF',
                letterSpacing: '-0.03em',
                cursor: 'pointer',
                whiteSpace: 'nowrap',
                marginTop: '2px',
              }}
            >
              공고 상세 보기
            </button>
          )}
        </div>

        {/* 촬영 기간 + 촬영 장소 */}
        <div style={{ display: 'flex', gap: '40px' }}>
          <Field label="촬영 기간" labelLarge style={{ flex: 1 }}>
            <Value large>{data.period}</Value>
          </Field>
          <Field label="촬영 장소" labelLarge style={{ flex: 1 }}>
            <Value large>{data.location}</Value>
          </Field>
        </div>

        {/* 지원자격 */}
        <div>
          <span style={{
            fontFamily: ff, fontSize: '20px', fontWeight: 700,
            color: C.bk, letterSpacing: '-0.03em', display: 'block', marginBottom: '10px',
          }}>
            지원자격
          </span>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            {[
              { label: '연령대', value: data.ageRange },
              { label: '키', value: data.height },
              ...(data.skills && data.skills.length > 0
                ? [{ label: '필요 스킬', skills: data.skills }]
                : []),
              { label: '언어', value: data.language },
            ].map((item, idx) => (
              <div key={item.label} style={{ display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
                <span style={{
                  fontFamily: ff, fontSize: '14px', fontWeight: 500,
                  color: C.sub, letterSpacing: '-0.03em', lineHeight: '160%',
                  flexShrink: 0, minWidth: '18px',
                }}>
                  {idx + 1}.
                </span>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                  <span style={{
                    fontFamily: ff, fontSize: '18px', fontWeight: 400,
                    color: C.bk, letterSpacing: '-0.03em', lineHeight: '140%',
                  }}>
                    {item.label}
                  </span>
                  {item.skills ? (
                    <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
                      {item.skills.map(sk => (
                        <span key={sk} style={{
                          padding: '5px 10px', background: C.g200, borderRadius: '6px',
                          fontFamily: ff, fontSize: '18px', fontWeight: 500,
                          color: C.bk, letterSpacing: '-0.03em',
                        }}>
                          {sk}
                        </span>
                      ))}
                    </div>
                  ) : (
                    <Value large>{item.value}</Value>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* 출연료 */}
        <Field label="출연료" labelLarge>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            {data.episodeCount && data.episodeCount !== '-' && (
              <span style={{
                padding: '4px 10px', border: `1px solid ${C.g200}`, borderRadius: '8px',
                fontFamily: ff, fontSize: '18px', fontWeight: 400, color: C.bk,
                letterSpacing: '-0.03em',
              }}>
                {data.episodeCount}
              </span>
            )}
            <Value large>{data.fee}</Value>
          </div>
        </Field>
      </div>
    </div>
  );
}
